<template>
  <div>
    <h1 class="dashboardTitle">Hi, {{ getFullname.split(" ")[0] }}</h1>
    <div class="milestoneContainer" :key="refreshKey">
      <h3 class="containerTitle">Here are some milestones for your goal</h3>
      <div class="milestoneCardHolder">
        <button
          class="milestoneCard"
          @click.stop="showSingle('one')"
          :disabled="getGoalData.one_complete"
        >
          <span class="circle">
            <img class="milestoneImg" src="../assets/confetti.svg" />
          </span>
          <h4 class="milestoneName">{{ getGoalData.criterial_one }}</h4>
          <input
            class="completeBox"
            type="checkbox"
            id="milestone1"
            name="milestone1"
            :disabled="getGoalData.one_complete"
            v-model="getGoalData.one_complete"
            @click.stop="complete('one')"
          />
          <label for="milestone1"> Complete</label>
        </button>
        <button
          class="milestoneCard"
          @click="showSingle('two')"
          :disabled="getGoalData.two_complete"
        >
          <span class="circle">
            <img class="milestoneImg" src="../assets/ribbon.svg" />
          </span>
          <h4 class="milestoneName">{{ getGoalData.criterial_two }}</h4>
          <input
            class="completeBox"
            type="checkbox"
            id="milestone1"
            name="milestone1"
            v-model="getGoalData.two_complete"
            :disabled="getGoalData.two_complete"
            @click.stop="complete('two')"
          />
          <label for="milestone1"> Complete</label>
        </button>
        <button
          class="milestoneCard"
          @click.stop="showSingle('three')"
          :disabled="getGoalData.three_complete"
        >
          <span class="circle">
            <img class="milestoneImg" src="../assets/bow.svg" />
          </span>
          <h4 class="milestoneName">{{ getGoalData.criterial_three }}</h4>
          <input
            class="completeBox"
            type="checkbox"
            id="milestone1"
            name="milestone1"
            :disabled="getGoalData.three_complete"
            v-model="getGoalData.three_complete"
            @click.stop="complete('three')"
          />
          <label for="milestone1"> Complete</label>
        </button>
      </div>
    </div>
    <div class="specificGoal">
      <h2>📊 Your specific goal</h2>
      <h4>"{{ getGoalData.specific_goal }}"</h4>
      <div class="progressContainer">
        <h5>{{ convertDate(getGoalData.start) }}</h5>
        <progress
          class="progressBar"
          id="goal"
          :value="scale(getGoalData.start, getGoalData.end)"
          max="100"
        ></progress>
        <h5>{{ convertDate(getGoalData.end) }}</h5>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["getFullname", "getGoalData"]),
  },
  data() {
    return {
      refreshKey: 0,
    };
  },
  beforeCreate() {
    const getGoalURI = "/goal/";
    this.$axios
      .get(getGoalURI)
      .then((result) => {
        this.setStoreGoal(result.data.data);
        console.log(result);
      })
      .catch((err) => {
        this.clearGoal();
        this.$router.push("/");
        console.log(err);
      });
  },
  methods: {
    ...mapActions(["setCriterial", "setStoreGoal", "clearGoal"]),
    showSingle(data) {
      this.setCriterial(data);
      this.$router.push({ path: "/dashboard/milestone" });
    },
    convertDate(date) {
      const dateDay = date.slice(8, 10);
      const dateMonth = date.slice(5, 7);
      const dateYear = date.slice(0, 4);
      const monthInWords = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return dateDay + " " + monthInWords[dateMonth - 1] + " " + dateYear;
    },
    scale(from, to) {
      const number = new Date();
      from = new Date(from);
      to = new Date(to);
      return Math.floor(((number - from) * 100) / (to - from));
    },
    complete(data) {
      const completeCiterialURI = `/goal/${this.getGoalData.id}/criterial`;
      const criterialData = {
        criterial: data,
      };
      this.$axios
        .post(completeCiterialURI, criterialData)
        .then((result) => {
          this.setStoreGoal(result.data.data);
          console.log(result);
          if (!result.data.data.is_active) {
            // Call celebration function
            alert("Congrats on completing your goal. Set a new one");
            this.clearGoal();
            this.$router.push("/");
          }
        })
        .catch((err) => {
          // this.$router.push('/home')
          console.log(err);
        });
      this.refreshKey = this.refreshKey > 10 ? 0 : this.refreshKey + 1;
    },
  },
};
</script>

<style scoped>
.dashboardTitle {
  margin-bottom: 30px;
}

.circle {
  position: relative;
  height: 80px;
  width: 80px;
  background-color: #fff;
  border-radius: 50%;
  display: inline-block;
}

.milestoneImg {
  position: absolute;
  height: 50px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.containerTitle {
  padding: 1rem;
}

.milestoneContainer {
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.01);
  border-radius: 50px;
  padding: 2rem 4rem;
}

.milestoneCardHolder {
  display: flex;
}

.milestoneCard {
  cursor: pointer;
  border-radius: 25px;
  margin: 20px;
  width: 215px;
  height: 250px;
  background-repeat: no-repeat;
  background-image: linear-gradient(#ffdb1c, #ffdb1c),
    linear-gradient(#ffffff, #ffffff);
  background-size: 100% 70px, 100%;
  box-shadow: 0px 7px 10px rgba(0, 0, 0, 0.03);
}

.milestoneCard:disabled {
  background-repeat: no-repeat;
  background-image: linear-gradient(#ffdb1c, #ffdb1c),
    linear-gradient(#f5f5f5, #f5f5f5);
  background-size: 100% 70px, 100%;
}

.milestoneCard:disabled > span {
  background-color: #f5f5f5;
}

.milestoneName {
  margin: 10px auto;
  width: 150px;
}

.completeBox {
}

.specificGoal {
  margin-top: 20px;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.01);
  border-radius: 50px;
}

.progressContainer {
  margin-top: 10px;
  display: flex;
  justify-content: space-evenly;
}
.progressContainer > h5 {
  padding-bottom: 5px;
}

.progressBar {
  border-radius: 7px;
  width: 60%;
  height: 5px;
}
.progressBar::-webkit-progress-bar {
  background-color: #23f038;
  border-radius: 7px;
  box-shadow: 1px 1px 5px 3px rgba(35, 240, 56, 0.5);
}
.progressBar::-webkit-progress-value {
  background-color: #fff;
  border-radius: 7px;
}
</style>
